// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fffd2e14","453":"c1d13a50","732":"c21b6436"}[chunkId] + ".chunk.js";
};